import React from "react";
import styled from "styled-components";
import { COLORS } from "../../../COLORS";

const Basic = () => {
  return (
    <StyledBasic>
      <strong className="name-formule"> ⭐ STARTER (BASIC)</strong>
      <span> 129.99 €</span>
      <ul>
        <li>🎉 Offre de bienvenue : 76.99 €</li>
        <li>✅ 1 mois </li>
        <li>✅ Format image : Carré (1:1) – Formats acceptés : .jpg, .jpeg</li>
        <li>✅ Taille maximale : 2 Mo </li>
        <li>✅ Emplacement : Business </li>
        <li>
          <strong>
            🔥 -20% sur 3 mois d’engagement (non cumulable avec l’offre de
            bienvenue)
          </strong>
        </li>
      </ul>
    </StyledBasic>
  );
};

export default Basic;
const StyledBasic = styled.div`
  background: ${COLORS.main};
  border: solid 2px ${COLORS.green};
  border-radius: 5px;
  color: white;
  padding: 10px;
  max-width: 23%;
  display: flex;
  flex-direction: column;
  .name-formule {
    display: block;
    font-size: 1.1em;
    text-align: center;
    color: ${COLORS.border_and_text_blue};
  }
  span {
    width: 100%;
    text-align: center;
    font-weight: 600;
    font-size: 1.2em;
    color: ${COLORS.orange_new};
    margin: 15px 0px;
  }
  ul {
    li {
      margin-top: 20px;
    }
  }
  @media screen and (max-width: 445px) {
    min-width: 85%;
    margin-bottom: 30px;
  }
`;
